<template>
  <vue-select
    style="width: 100%"
    :value="value"
    @search="getOptions"
    id="jurusan"
    :options="items"
    class="select-x"
    placeholder="Pilih Seri Tryout"
    @input="changed"
  ></vue-select>
</template>

<script>
import { HTTPAUTH } from "../lib/httplib";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    VueSelect,
  },
  name: "SeriesSelector",
  data() {
    return {
      items: [],
    };
  },
  props: ["value"],
  created() {
    this.getList("", 1);
  },
  methods: {
    getList(q, page) {
      HTTPAUTH.get(`/api/v1/admin/series/active?size=10&page=${page}&q=${q}`).then(
        (res) => {
          this.items = res.data.data;
        }
      );
    },
    getOptions(search, loading) {
      loading(true);
      this.getList(search, 1);
      loading(false);
    },
    changed(evt) {
      this.$emit("input", evt);
    },
  },
};
</script>

<style scoped>
</style>
